import { render, staticRenderFns } from "./ProductLcaByMaterial.vue?vue&type=template&id=237b731a"
import script from "./ProductLcaByMaterial.vue?vue&type=script&lang=js"
export * from "./ProductLcaByMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports